module.exports = __webpack_public_path__ + "img/exam_list.a3c33f16.png";